<ng-template let-t transloco>
    <mat-card class="h-full mat-elevation-z3 pl-2 hidden sm:flex">
        <button
            (click)="selectRange(item)"
            *ngFor="let item of customPresets"
            color="primary"
            mat-button
        >
            {{ item }}
        </button>
    </mat-card>

</ng-template>
